const statusFor = event => document.getElementById(`upload-status-${event.detail.id}`)

document.addEventListener("direct-upload:initialize", event => {
  const status = document.createElement("p")
  status.id = `upload-status-${event.detail.id}`
  status.className = "mt-2 text-sm text-brand-600"
  status.setAttribute("role", "status")
  status.textContent = `Preparando ${event.detail.file.name}…`
  event.target.insertAdjacentElement("afterend", status)
})
document.addEventListener("direct-upload:progress", event => {
  const status = statusFor(event)
  if (status) status.textContent = `Enviando ${event.detail.file.name}: ${Math.round(event.detail.progress)}%`
})
document.addEventListener("direct-upload:end", event => {
  const status = statusFor(event)
  if (status && !status.dataset.failed) status.textContent = "Envio concluído. Salvando os dados…"
})
document.addEventListener("direct-upload:error", event => {
  event.preventDefault()
  const status = statusFor(event)
  if (status) {
    status.dataset.failed = "true"
    status.setAttribute("role", "alert")
    status.textContent = "Não foi possível enviar o arquivo. Confira o formato e o tamanho, verifique sua conexão e tente novamente."
  }
})
document.addEventListener("change", event => {
  const input = event.target
  if (!(input instanceof HTMLInputElement) || input.type !== "file" || !input.dataset.maxUploadBytes) return
  if ([...input.files].some(file => file.size > Number(input.dataset.maxUploadBytes))) {
    input.value = ""
    alert("O arquivo excede o limite informado neste formulário. Escolha um arquivo menor.")
  }
})
